import { render } from "./ListNotes.vue?vue&type=template&id=74d099fc&ts=true"
import script from "./ListNotes.vue?vue&type=script&lang=ts"
export * from "./ListNotes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__